//公用js
import Vue from 'vue'
import axios from 'axios';
import qs from 'qs'
import { Message } from 'element-ui';

Vue.prototype.HOME = '/api'
var comview={}

comview.ExamMyqsn = (url,id,list,count) => {
    var data={service:'Examination.ExamMyqsn',userid:id,id:222}
    axios.post(url,qs.stringify(data))
      .then(res=>{
        count=parseInt(res.data.data.count)
        if(res.data.data.code==0){
          for(let i=0 ;i <res.data.data.info.length;i++){
            list.push(res.data.data.info[i])
          }
        }
        else{
          Message.error('目前没有自己创建的题库')
        }
      })
        .catch(function (error) { // 请求失败处理
      });  
}

comview.search = (url,data,callback) => {
  var data=data
  axios.post(url,qs.stringify(data))
    .then(res=>{
      callback(res,Message)
    })
      .catch(function (error) { // 请求失败处理
    });  
}
comview.typeview=(id,type)=>{
  var data={service:'Examination.ExamInfo',id:id,q_type:type,userid:localStorage.getItem('userid')}

}
comview.Section=(url,list)=>{
  var data ={service:'Examtask.Admininfo'}
  axios.post(url,qs.stringify(data))
  .then(res=>{
        for(let i=0 ;i <res.data.data.length;i++){
          list.push(res.data.data[i])
        }
  })
}
comview.SectionId=(url,list,id)=>{
  var data ={service:'Examtask.Adminson',id:id}
  list=[]
  axios.post(url,qs.stringify(data))
  .then(res=>{
      {
        if(res.data.data.code){
          Message.error('没有下级人员')  
        }
        else{
          for(let i=0 ;i <res.data.data.length;i++){
              list.push(res.data.data[i])
            }
        }
      }
  })
}
export{
    comview
}



// WEBPACK FOOTER //
// ./src/assets/js/common.js